import React from "react";
import Tag from "./Tag";

const TagList = (props: { length: "short" | "long", tags: server.dto.TagSmall[] }) => {
  const { length, tags } = props;

  if (tags.length === 0) return null;

  return (
    <div className="tag-list">
      {tags.map((t) => <Tag
        key={t.tagId}
        title={t.title}
        label={length === "short" ? t.code : t.title}
        color={t.hexColor} />)}
    </div>
  );
};

export default TagList;